import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en",
    element: <Home />,
  },
  {
    path: "/de",
    element: <Home />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "/en/article/:slug",
    element: <Article />,
  },
  {
    path: "/de/article/:slug",
    element: <Article />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;